<!-- eslint-disable no-undef -->
<template>
  <div class="index page test2">
    <headerApp
      :appLinkShow="appLinkShow"
      wapTitle="拍卖"
      :spreadID="'0'"
      :app-link="appLink"
      :soShow="true"
      @gotoApp="gotoApp"
    ></headerApp>
    <van-loading v-if="isLoading" />
    <!-- 头部 -->

    <HomeTabs activeTab="2-0" />
    <!-- 轮播 -->
    <div class="swiper" v-if="bannerList.length">
      <van-swipe
        class="my-swipe"
        :autoplay="5000"
        indicator-color="white"
        @change="swipeScFun"
      >
        <van-swipe-item v-for="(item, i) in bannerList" :key="i">
          <img @click="jumpLink(item, i)" :src="item.picture" />
        </van-swipe-item>
      </van-swipe>
    </div>
    <van-row class="iconList">
      <van-col
        @click="iconListJump(item.button_type, item)"
        :span="buttons.length == 4 ? '6' : '4'"
        v-for="(item, i) in buttons"
        :key="i + 'buttons'"
      >
        <img :src="item.picture" alt="" />
        <img
          v-if="item.is_hot == 1"
          class="hotIcon"
          src="@/assets/img/hot_icon.gif"
          alt=""
        />
        <div class="iconListTitle">{{ item.title }}</div>
      </van-col>
    </van-row>
    <div class="advertisementIndex" v-if="advSpe1.img_url.length">
      <img class="advLogo" src="@/assets/img/Group 201@2x.png" alt="" />
      <img @click="iconJump(advSpe1, '1')" :src="advSpe1.img_url[0]" alt="" />
    </div>
    <!-- 改版 广告位 -->
    <div class="ad-wrap">
      <div class="bottom-ad" v-if="advSpe3.img_url.length">
        <img :src="advSpe3.img_url[0]" @click="iconJump(advSpe3, '3')" />
        <img class="advLogo" src="@/assets/img/Group 201@2x.png" alt="" />
      </div>
      <div class="bottom-ad" v-if="advSpe4.img_url.length">
        <img :src="advSpe4.img_url[0]" @click="iconJump(advSpe4, '4')" />
        <img class="advLogo" src="@/assets/img/Group 201@2x.png" alt="" />
      </div>
    </div>
    <!-- 拍卖会列表 改版 今日可拍 -->
    <div class="indexAuc" v-if="todayAuctionList.length">
      <h3
        class="indexTit align-items"
        @click="jumpRouterFun('/preview?active=0' + waterLink, '6')"
      >
        <span class="name">今日在拍</span><span class="arrow"></span>
        <!-- <div @click="jumpRouterFun('/preview?active=0'+waterLink,'6')" class="more">查看全部</div> -->
      </h3>
      <jinRiCustomSwipe :todayAuctionList="todayAuctionList"></jinRiCustomSwipe>
    </div>
    <div class="indexAuc" v-if="soonspecials.length">
      <h3
        class="indexTit align-items"
        @click="jumpRouterFun('/preview?active=1' + waterLink, '7')"
      >
        <span class="name">即将拍卖</span><span class="arrow"></span>
        <!-- <div class="more">全部</div> -->
      </h3>
      <!-- 改版内容 -->
      <jiJiangCustomSwipe
        :soonSpecialsList="soonSpecialsList"
      ></jiJiangCustomSwipe>
    </div>
    <!--拍卖结果-->
    <div class="indexResult">
      <h3
        class="indexTit align-items"
        @click="jumpRouterFun('/preview?active=2' + waterLink, '8')"
      >
        <span class="name">拍卖结果</span><span class="arrow"></span>

        <!-- <div class="more">全部</div> -->
      </h3>
      <div class="aucSwiper">
        <div class="swiper-wrapper">
          <template v-for="(item, i) in result">
            <dl
              class="swiper-slide"
              style="width: 6.5rem;"
              @click="
                jumpDetail(
                  (item.type == 1 ? '/special/' : '/session/') +
                    item.source_code +
                    waterLink,
                  item,
                  '8',
                  i
                )
              "
              :key="i"
            >
              <dt>
                <img :src="item.cover_pic" alt="" />

                <div class="resultPrice" v-if="item.total_price">
                  <span>成交额：</span><span>{{ item.total_price }}</span>
                </div>
                <div
                  class="aucStatusBoxType2"
                  v-if="item.bid_type == 2 || item.bid_type == 1"
                >
                  <!-- v-if="item.bid_type==1" -->
                  <img
                    v-if="item.bid_type == 2"
                    src="@/assets/img/bid_type_1.png"
                    alt=""
                  />
                  <img
                    v-if="item.bid_type == 1"
                    src="@/assets/img/bid_type_2.png"
                    alt=""
                  />
                </div>
              </dt>
              <dd>
                <h4 class="title" style="">{{ item.name }}</h4>
                <p class="time">{{ item.organ_name + " " + item.city }}</p>
                <p class="time">{{ item.auction_date }}</p>

                <p
                  class="aucFlag"
                  v-if="item.live_info && item.live_info.label_list.length"
                >
                  <span
                    v-for="(flag, index) in item.live_info.label_list"
                    :key="index"
                    >{{ flag.name }}</span
                  >
                </p>
              </dd>
            </dl>
          </template>
        </div>
      </div>
    </div>
    <div class="advertisementIndex" v-if="advSpe2.img_url.length">
      <img class="advLogo" src="@/assets/img/Group 201@2x.png" alt="" />
      <img @click="iconJump(advSpe2, '2')" :src="advSpe2.img_url[0]" alt="" />
    </div>

    <!--拍卖广告-->

    <!--排行榜-->
    <!-- <div class="indexRank">
            <h3 class="indexTit"><span class="name">排行榜</span>
            </h3>
            <div class="aucSwiper">
                <div class="swiper-wrapper">
                    <dl class="swiper-slide" style="width: 6.5rem;" v-for="(item,i) in rankMenu" :key="i">
    
                        <dt @click="jumpRankLink(item,i)">
                            <img :src="item.picture" alt="">
    
                            <div class="resultPrice">
                                <div>{{item.title}}</div>
                                <div>{{item.sub_title}}</div>
                            </div>
    
                        </dt>
    
                    </dl>
                </div>
            </div>
        </div> -->
    <!-- 拍卖速递 -->

    <div class="indexHotList">
      <h3 class="indexTit"><span>推荐拍品</span></h3>
      <div class="searchTop">
        <div class="listText">
          <div
            @click="sortFun(1)"
            class="sortBox"
            :style="orderby == 1 || orderby == 2 ? 'color:#000000;' : ''"
          >
            开始时间
            <img v-if="orderby == 1" src="../assets/img/sort2.png" />
            <img v-else-if="orderby == 2" src="../assets/img/sort3.png" />
            <img v-else src="../assets/img/sort1.png" />
          </div>
          <div
            @click="sortFun(2)"
            class="sortBox"
            :style="orderby == 3 || orderby == 4 ? 'color:#000000;' : ''"
          >
            估价排序
            <img v-if="orderby == 3" src="../assets/img/sort2.png" />
            <img v-else-if="orderby == 4" src="../assets/img/sort3.png" />
            <img v-else src="../assets/img/sort1.png" />
          </div>
          <!-- <div @click="changeSortFun(1)" class="sortBox sortCheck">
                        <van-checkbox v-model="checked">只看可拍</van-checkbox>
                    </div> -->
        </div>

        <LotFilter ref="filter-com" @search="search" :type="4" />
      </div>
      <div class="searchBottom">
        <div @click="changeSortFun(1)" :class="{ activeDiv: bidSortType == 1 }">
          只看可拍
        </div>
        <div @click="changeSortFun(2)" :class="{ activeDiv: bidSortType == 2 }">
          委托出价
        </div>
        <div @click="changeSortFun(3)" :class="{ activeDiv: bidSortType == 3 }">
          竞价中
        </div>
      </div>
      <!-- <div class="indexHotTabs">
                <div class="indexHotTabsBox">
                    <div class="indexTabsCon" v-if="hotClass.length">
                        <div class="indexHotTab" v-for="(classItem,i) in hotClass" :key="i" :class="{'active':i==hotIndex}" @click="onClickHot(classItem.name,i)">{{classItem.name}}</div>
                    </div>
    
                </div>
    
            </div> -->
      <div class="hotList">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad(classCode)"
        >
          <div style="width: calc(50% - 0.35rem);display: inline-block;">
            <template v-for="(item, idx) in hotData">
              <div v-if="idx % 2 == 0" class="fix dl" :key="idx">
                <div class="dt">
                  <img
                    @click="jumpRouter(item, idx)"
                    :src="item.coverPic"
                    alt=""
                  />
                  <div @click.stop="followFun(item)" class="followBox">
                    <img
                      v-if="item.isFocus == 1"
                      src="../assets/img/follow_on.png"
                    />
                    <img
                      v-if="item.isFocus == 0"
                      src="../assets/img/follow_off.png"
                    />
                  </div>

                  <img class="restrictTransportIcon" v-if="item.RestrictTransport==2"  src="../assets/img/restrictTransport_icon.png" alt="">
                </div>
                <div class="dd" @click="jumpRouter(item, idx)">
                  <div class="labelBox">
                    <template v-if="item.BidAuctionType > 0">
                      <div class="greenBox" v-if="item.status != 4">
                        委托出价
                      </div>
                      <div class="redBox" v-if="item.status == 4">前往出价</div>
                    </template>
                    <div
                      class="timeBox"
                      :style="
                        item.BidAuctionType > 0
                          ? 'float:right;margin-top: 3px;'
                          : ''
                      "
                    >
                      {{ item.date }}
                    </div>
                  </div>
                  <h4 class="hotName">{{ item.detail.workName }}</h4>

                  <div class="hotInfo">
                    <div class="company">
                      <div class="companyCity">
                        {{ item.company + " " + item.city }}
                      </div>
                      <span class="companySpan">{{
                        item.watch_num + "次围观"
                      }}</span>
                    </div>
                    <template v-if="isMem == 1">
                      <div class="price">
                        {{ item.price.label }}:<i>{{ item.price.smallText }}</i
                        ><span>{{ item.price.text }}</span>
                      </div>
                      <div style="padding-left: 2.15rem;" class="price">
                        <i>{{ item.price.otherSmallText }}</i
                        ><span>{{ item.price.otherText }}</span>
                      </div>
                    </template>
                    <template v-else>
                      <div class="price">
                        {{ item.price.label }}:<i>{{ item.price.smallText }}</i
                        ><span>{{
                          item.price.type == "gujia" ||
                          item.price.type == "start_price" ||
                          item.price.type == "now_price"
                            ? item.price.text
                            : "****"
                        }}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div
            style="width: calc(50% - 0.35rem);display: inline-block;margin-left: 0.5rem;"
          >
            <template v-for="(item, idx) in hotData">
              <div v-if="idx % 2 != 0" class="fix dl" :key="idx">
                <div class="dt">
                  <img
                    @click="jumpRouter(item, idx)"
                    :src="item.coverPic"
                    alt=""
                  />
                  <div @click.stop="followFun(item)" class="followBox">
                    <img
                      v-if="item.isFocus == 1"
                      src="../assets/img/follow_on.png"
                    />
                    <img
                      v-if="item.isFocus == 0"
                      src="../assets/img/follow_off.png"
                    />
                  </div>
                </div>
                <div class="dd" @click="jumpRouter(item, idx)">
                  <div class="labelBox">
                    <template v-if="item.BidAuctionType > 0">
                      <div class="greenBox" v-if="item.status != 4">
                        委托出价
                      </div>
                      <div class="redBox" v-if="item.status == 4">前往出价</div>
                    </template>
                    <div
                      class="timeBox"
                      :style="
                        item.BidAuctionType > 0
                          ? 'float:right;margin-top: 3px;'
                          : ''
                      "
                    >
                      {{ item.date }}
                    </div>
                  </div>
                  <h4 class="hotName">{{ item.detail.workName }}</h4>

                  <div class="hotInfo">
                    <!-- <div class="company">{{item.date+' '+item.company+' '+item.city}}</div> -->
                    <div class="company">
                      <div class="companyCity">
                        {{ item.company + " " + item.city }}
                      </div>
                      <span class="companySpan">{{
                        item.watch_num + "次围观"
                      }}</span>
                    </div>
                    <template v-if="isMem == 1">
                      <div class="price">
                        {{ item.price.label }}:<i>{{ item.price.smallText }}</i
                        ><span>{{ item.price.text }}</span>
                      </div>
                      <div style="padding-left: 1.5rem;" class="price">
                        <i>{{ item.price.otherSmallText }}</i
                        ><span>{{ item.price.otherText }}</span>
                      </div>
                    </template>
                    <template v-else>
                      <div class="price">
                        {{ item.price.label }}:<i>{{ item.price.smallText }}</i
                        ><span>{{
                          item.price.type == "gujia" ||
                          item.price.type == "start_price" ||
                          item.price.type == "now_price"
                            ? item.price.text
                            : "****"
                        }}</span>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </van-list>
      </div>
    </div>
    <DownLoadApp ref="downloadPop"></DownLoadApp>
    <watermark v-if="showWater"></watermark>
  </div>
</template>

<script>
import defaultImg from "../assets/img/default.png";
import headImg from "../assets/img/icon_default avatar_50_light@2x.png";
import LotFilter from "@/views/preview/component/LotFilter.vue";
import {
  indexBannerV2,
  indexNews,
  indexAdv,
  indexHotV2,
  getSingleList,
  indexFocus,
  tokenGet,
} from "@/api/index";
import { history } from "@/api/auction";
import { getWXConfig } from "@/assets/js/weixinShare";
import Swiper from "swiper";
import headerApp from "@/components/headerApp";
import lottie from "@/components/common/lottie";
// import {
//     liveIcon
// } from "../../src/assets/img/live_icon.json";
import DownLoadApp from "@/components/common/downloadApp";
import { getMemType } from "@/api/auction";
// import AppDownload from "@/components/AppDownload";
import { mapActions, mapGetters } from "vuex";
import watermark from "@/components/common/watermark";
import { scMdFunc, gotoLogin } from "@/assets/js/scData";
import HomeTabs from "@/components/HomeTabs.vue";
import jinRiCustomSwipe from "./jinRiCustomSwipe/index.vue";
import jiJiangCustomSwipe from "./jiJiangCustomSwipe/index.vue";
// import 'swiper/dist/css/swiper.css';
const liveIcon = require("../assets/img/live_icon_2.json");
const liveIcon3 = require("../assets/img/live_icon_3.json");
export default {
  data() {
    return {
      floatingPics: {
        link: "",
        picture: "",
      },
      heartOptions: {
        animationData: liveIcon,
        loop: true,
        autoplay: true,
      },
      heartOptions3: {
        animationData: liveIcon3,
        loop: true,
        autoplay: true,
      },
      token_data: "",
      isMem: 0,
      t: 0,
      floatingWindowFlag: true,
      waterLink: "",
      showWater: false,
      singleList: [],
      bannerList: [],
      swiperNews: [],
      buttons: [],
      appLink: "/2/8/0",
      topSpeciel: [],
      searchObj: {},
      appLinkShow: true,
      active: 0,
      defaultImg: "",
      headImg: "",
      // rankArtists: [],
      // rankClasses: [],
      // rankCompany: [],
      // rankHistory: [],
      // rankSingle: [],
      rankMenu: [],
      newsList: [],
      advList: [],
      onspecials: [],
      soonspecials: [],
      todayAuctionList: [],
      soonSpecialsList: [],
      resultSpecials: [],
      result: [],
      rankArtist: [],
      showClass: false,
      classCode: '',
      orderby: 0,
      hotClass: [],
      hotData: [],
      wapLink: "",
      isLoading: true,
      classPage: 1,
      loading: false,
      finished: false,
      tabFix: false,
      headerH: "",
      isLogin: 0,
      advSpe1: {
        img_url: [],
      },
      advSpe2: {
        img_url: [],
      },
      advSpe3: {
        img_url: [],
      },
      advSpe4: {
        img_url: [],
      },
      hotIndex: 0,
      bidSortType: 0,
      secIndex: 1,
      hotClassCode: 0,
    };
  },
  created() {
    // this.getBanks();
    this.getNews();
    this.getHot();
    this.getAdv();
    this.getMemTypeFun();
    this.getSingleListFun();
    this.defaultImg = defaultImg;
    this.headImg = headImg;
    this.wapLink = this.$route.query.from
      ? "?from=" + this.$route.query.from
      : "";
  },
  mounted() {
    this.t = Date.now();
    if (
      (this.$route.query.from && this.$route.query.from == 1) ||
      this.$route.query.from == 1
    ) {
      this.showWater = true;
      this.waterLink = "?from=" + this.$route.query.from;
    }

    if (!this.getIsLoadIng) {
      this.getPageHome([
        0,
        () => {
          this.filteData();
        },
      ]);
    } else {
      this.filteData();
    }
    scMdFunc("allPageView", {
      cur_page: "1",
    });
    window.scroll({
      top: 0,
      left: 0,
    });
    this.getBanner();
    tokenGet().then((res) => {
      if (res.data.code == 0) {
        this.token_data = res.data.data.token_data;
      }
    });
  },
  asyncData({ store }) {
    return store.dispatch("pageIndex/getPageHome", [0, null, () => {}]);
  },
  computed: {
    ...mapGetters({
      getIsLoadIng: "pageIndex/getIsLoadIng",
      getData: "pageIndex/getData",
    }),
  },
  methods: {
    ...mapActions({
      getPageHome: "pageIndex/getPageHome",
    }),
    swipeScFun(index) {
      scMdFunc("bannerExpose", {
        cur_page: "1",
        cur_moudle: "1-3",
        cur_button: "1-3-" + (Number(index) + 1),
        banner_type_id: this.bannerList[index].type,
        banner_order_id: this.bannerList[index].orderId,
        banner_advertiser_id: this.bannerList[index].advertiserId,
        remarks: this.bannerList[index].remarks,
        banner_link_type: this.bannerList[index].ad_type,
        banner_link: this.bannerList[index].link,
        banner_englishName: this.bannerList[index].englishName,
      });
    },
    jumpRankLink(e, i) {
      scMdFunc("allClick", {
        cur_page: "1",
        cur_moudle: "1-9",
        cur_button: "1-9-" + (Number(i) + 1),
      });
      this.$router.push({
        path: "/rankList?active=" + i,
      });
    },
    jumpDetail(e, item, i, index) {
      if (item.type == 1) {
        scMdFunc("allClick", {
          cur_page: "1",
          cur_moudle: "1-" + i,
          cur_button: "1-" + i + "-" + Number(index + 1),
          auction_specia_performance_id_pk: item.special_id,
          auction_specia_performance_id: item.special_code,
          the_auction_id_pk: item.session_id,
          the_auction_id: item.session_code,
          auction_company_id: item.organ_id,
          auction_company_code: item.organ_code,
          auction_state:
            item.status == 1
              ? "待拍卖"
              : item.status == 2
              ? "预展中"
              : item.status == 3
              ? "待预展"
              : item.status == 4
              ? "拍卖中"
              : item.status == 5
              ? "已结拍"
              : "",
          auction_type: item.bid_type,
        });
      } else {
        scMdFunc("allClick", {
          cur_page: "1",
          cur_moudle: "1-" + i,
          cur_button: "1-" + i + "-" + Number(index + 1),
          the_auction_id_pk: item.session_id,
          the_auction_id: item.session_code,
          auction_company_id: item.organ_id,
          auction_company_code: item.organ_code,
          auction_state:
            item.status == 1
              ? "待拍卖"
              : item.status == 2
              ? "预展中"
              : item.status == 3
              ? "待预展"
              : item.status == 4
              ? "拍卖中"
              : item.status == 5
              ? "已结拍"
              : "",
          auction_type: item.bid_type,
        });
      }

      this.$router.push({
        path: e,
        query: {
          scId: "",
          scFrom:
            "1-" +
            i +
            "-" +
            Number(index + 1) +
            "-" +
            (item.type == 1 ? item.special_code : "0") +
            "-0",
        },
      });
    },
    jumpRouterFun(e, i) {
      scMdFunc("allClick", {
        cur_page: "1",
        cur_moudle: "1-" + i,
        cur_button: "1-" + i + "-" + "0",
      });
      this.$router.push({
        path: e,
      });
    },
    jumpLink(e, i) {
      var isApp = /(SwiftTuLu|ArtronTulu|HarmonyOSTulu)/g.test(
        window.navigator.userAgent
      );
      let bridge = window.WebViewJavascriptBridge;
      scMdFunc("allClick", {
        cur_page: "1",
        cur_moudle: "1-3",
        cur_button: "1-3-" + (Number(i) + 1),
        banner_type_id: e.type,
        banner_order_id: e.orderId,
        banner_advertiser_id: e.advertiserId,
        remarks: e.remarks,
        banner_link_type: e.ad_type,
        banner_link: e.link,
        banner_englishName: e.englishName,
      });
      if (isApp) {
        if (e.type == 8) {
          bridge.callHandler(
            "appSessionDetail",
            {
              sessionCode: e.param,
              from_page: "1",
              from_module: "1-3",
              from_button: "1-3-" + (Number(i) + 1),
              from_page_pk: "",
            },
            function() {}
          );
        } else if (e.type == 7) {
          bridge.callHandler(
            "appSecLink",
            {
              secLink: e.param,
              from_page: "1",
              from_module: "1-3",
              from_button: "1-3-" + (Number(i) + 1),
              from_page_pk: "",
            },
            function() {}
          );
        } else if (e.type == 6) {
          bridge.callHandler(
            "appArtDetail",
            {
              artCode: e.param,
              from_page: "1",
              from_module: "1-3",
              from_button: "1-3-" + (Number(i) + 1),
              from_page_pk: "",
            },
            function() {}
          );
        } else {
          window.location.href = e.wap_url;
        }
      } else {
        window.location.href = e.wap_url;
      }
    },
    sortFun(e) {
      if (e == 1) {
        scMdFunc("allClick", {
          cur_page: "1",
          cur_moudle: "1-10",
          cur_button: "1-10-1",
        });
      }
      if (e == 2) {
        scMdFunc("allClick", {
          cur_page: "1",
          cur_moudle: "1-10",
          cur_button: "1-10-2",
        });
      }

      switch (this.orderby) {
        case 0:
          if (e == 1) {
            this.orderby = 1;
          }
          if (e == 2) {
            this.orderby = 3;
          }
          break;
        case 1:
          if (e == 1) {
            this.orderby = 2;
          }
          if (e == 2) {
            this.orderby = 3;
          }

          break;
        case 2:
          if (e == 1) {
            this.orderby = 1;
          }
          if (e == 2) {
            this.orderby = 3;
          }
          break;
        case 3:
          if (e == 1) {
            this.orderby = 1;
          }
          if (e == 2) {
            this.orderby = 4;
          }
          break;
        case 4:
          if (e == 1) {
            this.orderby = 1;
          }
          if (e == 2) {
            this.orderby = 3;
          }
          break;
      }
      this.classPage = 1;
      this.hotData = [];
      this.getHot(this.classCode);
    },
    changeSortFun(e) {
      if (this.bidSortType == 0 || this.bidSortType != e) {
        this.bidSortType = e;
      } else {
        this.bidSortType = 0;
      }
      this.finished = false;
      this.classPage = 1;
      this.hotData = [];
      this.getHot(this.classCode);
    },
    search(params) {
      scMdFunc("allClick", {
        cur_page: "1",
        cur_moudle: "1-10",
        cur_button: "1-10-3",
      });
      this.searchObj = params;
      this.classPage = 1;
      this.hotData = [];
      this.getHot(this.classCode);
    },
    jumpRouter(item, i) {
      scMdFunc("allClick", {
        cur_page: "1",
        cur_moudle: "1-11",
        cur_button: "1-11-" + (Number(i) + 1),
        auction_items_id: item.artCode,
        lot_category1_id: item.classCodeOne,
        lot_category2_id: item.classCodeTwo,
        auction_specia_performance_id_pk: item.special_id,
        auction_specia_performance_id: item.special_code,
        the_auction_id_pk: item.session_id,
        the_auction_id: item.session_code,
        auction_company_id: item.organ_id,
        auction_company_code: item.organ_code,
        auction_state:
          item.status == 1
            ? "待拍卖"
            : item.status == 2
            ? "预展中"
            : item.status == 3
            ? "待预展"
            : item.status == 4
            ? "拍卖中"
            : item.status == 5
            ? "已结拍"
            : "",
        auction_type: item.BidAuctionType,
      });

      window.location.href =
        "https://m-auction.artron.net/trade/auction/detail/" +
        item.artCode +
        "?scId=&scFrom=1-11-" +
        (Number(i) + 1) +
        "-" +
        item.special_code +
        "-" +
        item.artCode;
      // this.$router.push({
      //     path: "/productdetail/" + item.artCode + this.waterLink,
      // });
    },
    followFun(e) {
      let parmas = {
        special_type: 5,
        action: e.isFocus == 0 ? 1 : 2,
        code: e.artCode,
      };
      if (!this.isLogin) {
        //未登录
        gotoLogin();
      } else {
        indexFocus(parmas).then((res) => {
          if (res.code == 0) {
            if (e.isFocus == 0) {
              this.$toast("关注成功");
            }

            e.isFocus = e.isFocus == 0 ? 1 : 0;
          }
        });
      }
    },
    iconListJump(i, e) {
      //1、估值 2、拍卖直播 3、报告 4、雅昌会员 5、同步拍 6、限时拍 7、专题 8 可拍专场  9 拍品征集
      //10:ForYou 11:推荐 13:拍卖 14：专题列表 15：行情
      //16:热点 17:资讯 18:专稿  19:市场报告
      //关注页 20 拍品 21 专场 22拍行 23 品类

      switch (i) {
        case 0:
          // window.location.href = "https://m-auction.artron.net/live"
          scMdFunc("allClick", {
            cur_page: "1",
            cur_moudle: "1-4",
            cur_button: "1-4-" + e.button_id,
          });
          window.location.href = e.wap_url;
          break;
        case 2:
          scMdFunc("allClick", {
            cur_page: "1",
            cur_moudle: "1-4",
            cur_button: "1-4-" + e.button_id,
          });

          window.location.href = "https://m-auction.artron.net/live";
          // this.$router.push({
          //     path: "/preview?active=0&bidActive=2"
          // });
          break;
        case 1:
          scMdFunc("allClick", {
            cur_page: "1",
            cur_moudle: "1-4",
            cur_button: "1-4-" + e.button_id,
          });
          this.$refs.downloadPop.gotoAppDownload("/2/19/0", 0);
          break;
        case 3:
          scMdFunc("allClick", {
            cur_page: "1",
            cur_moudle: "1-4",
            cur_button: "1-4-" + e.button_id,
          });
          //  this.$refs.downloadPop.gotoAppDownload('/2/17/0', 0);
          window.location.href = e.wap_url;

          break;
        case 4:
          scMdFunc("allClick", {
            cur_page: "1",
            cur_moudle: "1-4",
            cur_button: "1-4-" + e.button_id,
          });
          window.location.href = e.wap_url;
          // window.location.href = "https://tulu.artron.net/wap/share/vipmember?token_data=" + this.token_data
          break;
      }
    },
    iconJump(e, i) {
      scMdFunc("allClick", {
        cur_page: "1",
        cur_moudle: "1-5",
        cur_button: "1-5-" + i,
        banner_type_id: e.type,
        banner_order_id: e.orderId,
        banner_advertiser_id: e.advertiserId,
        remarks: e.remarks,
        banner_link_type: e.ad_type,
        banner_link: e.link,
        banner_englishName: e.englishName,
      });
      window.location.href = e.stats_click;
    },
    trackBannerExpose(advData, buttonSuffix) {
      if (advData && advData.type !== undefined) {
        scMdFunc("bannerExpose", {
          cur_page: "1",
          cur_moudle: "1-5",
          cur_button: "1-5-" + buttonSuffix,
          banner_type_id: advData.type,
          banner_order_id: advData.orderId,
          banner_advertiser_id: advData.advertiserId,
          remarks: advData.remarks,
          banner_link_type: advData.ad_type,
          banner_link: advData.link,
          banner_englishName: advData.englishName,
        });
      }
    },
    getMemTypeFun() {
      getMemType().then((res) => {
        if (res.code == 0) {
          this.isMem = res.data.isMember;
        }
      });
    },
    gotoTulu(e, i) {
      // scMdFunc('clickVip', {
      //     current_page: e,
      //     button_name: i
      // })

      this.gotoApp();
    },
    onLoad() {
      this.getHot(this.classCode || "");
    },
    gotoApp() {
      this.$refs.downloadPop.gotoAppDownload(this.appLink, 0);
    },
    floatingUrl() {
      window.location.href = this.floatingPics.wap_url;
    },
    filteData() {
      this.bannerList = this.$store.state["pageIndex"]["data"].slidepics;
      this.swiperNews = this.$store.state["pageIndex"]["data"].slicenews;
      this.buttons = this.$store.state["pageIndex"]["data"].buttons;
      this.topSpeciel = this.$store.state["pageIndex"]["data"].speical;
      this.onspecials = this.$store.state["pageIndex"]["data"].onspecials;
      this.soonspecials = this.$store.state["pageIndex"]["data"].soonspecials;
      this.resultSpecials = this.$store.state["pageIndex"][
        "data"
      ].result_specials;
      this.result = this.$store.state["pageIndex"]["data"].result;
      this.advSpe1 = this.$store.state["pageIndex"]["data"].ad_pos1;
      this.advSpe2 = this.$store.state["pageIndex"]["data"].ad_pos2;
      this.advSpe3 = this.$store.state["pageIndex"]["data"].ad_pos3;
      this.advSpe4 = this.$store.state["pageIndex"]["data"].ad_pos4;
      this.rankMenu = this.$store.state["pageIndex"]["data"].rank_top_menu;
      this.isLogin = this.$store.state["pageIndex"]["data"].isLogin;
      this.isLoading = false;

      history({
        type: 19,
      }).then((res) => {
        if (res.code === 0) {
          let meta = res.data.meta;
          document.title = meta.title;

          window.AFedWxShareData = {
            title: meta.shareTitle,
            imgUrl:
              meta.pic || "https://pubunder.artron.net/pubimgs/m/wxImgAuc.png",
            desc: meta.description || "",
            link: window.location.href,
          };
          getWXConfig(window.AFedWxShareData);

          let head = document.getElementsByTagName("head");

          if (!document.querySelector("meta[name=description]")) {
            let meta2 = document.createElement("meta");
            meta2.name = "description";
            meta2.content = meta.description || "";
            head[0].appendChild(meta2);
          } else {
            document
              .querySelector("meta[name=description]")
              .setAttribute("content", meta.description || "");
          }
        }
      });
    },
    getSingleListFun() {
      getSingleList().then((res) => {
        if (res.code == 0) {
          this.singleList = res.data.single;
        }
      });
    },
    getBanner() {
      indexBannerV2().then((res) => {
        if (res.code == 0) {
          this.isLoading = false;
          this.todayAuctionList = res.data.today_auction_specials || [];
          this.soonSpecialsList = res.data.soonspecials || [];
          this.bannerList = res.data.slidepics;
          this.swiperNews = res.data.slicenews;
          this.buttons = res.data.buttons;
          this.topSpeciel = res.data.speical;
          this.onspecials = res.data.onspecials;
          this.soonspecials = res.data.soonspecials;
          this.resultSpecials = res.data.result_specials;

          this.result = res.data.result;
          // if (res.data.floating_pics.picture) {
          //     this.floatingPics = res.data.floating_pics
          //     this.floatingWindowFlag = true
          // } else {
          //     this.floatingWindowFlag = false
          // }
          this.advSpe1 = res.data.ad_pos1;
          this.advSpe2 = res.data.ad_pos2;
          this.advSpe3 = res.data.ad_pos3;
          this.advSpe4 = res.data.ad_pos4;
          this.rankMenu = res.data.rank_top_menu;
          this.isLogin = res.data.isLogin;

          this.trackBannerExpose(this.advSpe1, "1");
          this.trackBannerExpose(this.advSpe2, "2");
          this.trackBannerExpose(this.advSpe3, "3");
          this.trackBannerExpose(this.advSpe4, "4");
        }
      });
      // indexGatherList().then((res) => {
      //   if (res.code == 0) {
      //     this.isLoading = false;
      //     this.todayAuctionList = res.data.today_auction_specials || [];
      //     this.soonSpecialsList = res.data.soonspecials || [];
      //   }
      // });
    },
    getNews() {
      indexNews().then((res) => {
        if (res.code == 0) {
          this.newsList = res.data.list;
          setTimeout(function() {
            new Swiper(".deepReadSwiper", {
              direction: "vertical",
              autoplay: true,
              loop: true,
            });
          }, 200);
        }
      });
    },
    // getBanks() {
    //     indexRank().then((res) => {
    //         if (res.code == 0) {
    //             // this.rankArtists = res.data.artist
    //             // this.rankClasses = res.data.classes
    //             // this.rankCompany = res.data.company
    //             // this.rankHistory = res.data.history
    //             // this.rankSingle = res.data.single
    //             // this.rankArtist = res.data.artist[0].list
    //             // this.className = res.data.classes[0].class_name
    //             setTimeout(function () {
    //                 new Swiper('.rankSwiper', {
    //                     slidesPerView: 'auto',
    //                     loop: false
    //                 });
    //             }, 500)
    //         }
    //     });
    // },

    getAdv() {
      indexAdv().then((res) => {
        if (res.code == 0) {
          this.advList = res.data.list;
        }
      });
      setTimeout(function() {
        new Swiper(".adColumnSwiper", {
          slidesPerView: "auto",
          loop: false,
        });
      }, 200);
    },
    getHot(code) {
      this.loading = true;
      let parmas = {
        page: this.classPage,
        pagesize: 10,
        is_search: 1,
        isNew: 12,
        special_type: 4,
        classCode: code || '',
        orderby: this.orderby,
        selection: this.secIndex,
        bid_sort_type: this.bidSortType,
        ...this.searchObj,
      };
      indexHotV2(parmas).then((res) => {
        if (res.code == 0) {
          // this.hotClass = res.data.artClassList.length ? res.data.artClassList : this.hotClass;
          if (!res.data.dataList && res.data.morePage != 1) {
            this.loading = false;
            this.finished = true;
          }
          if (res.data.dataList) {
            this.hotData = this.hotData.concat(res.data.dataList);
            this.loading = false;
            this.classPage++;
            if (res.data.morePage == 0) {
              this.finished = true;
            }
          }
        }
      });
    },
    screenClass() {
      this.showClass = !this.showClass;
    },
    closeScreen() {
      this.showClass = false;
    },
    selectClass(name) {
      let artistList = this.rankArtists,
        that = this;
      artistList.forEach(function(item) {
        if (item.class_name == name) {
          that.rankArtist = [];
          that.rankArtist = item.list;
          that.className = item.class_name;
        }
      });
      this.closeScreen();
    },
    onClickHot(name, i) {
      this.hotData = [];
      this.hotIndex = i;
      // this.classCode = this.hotClass[i].classCode
      this.classPage = 1;
      this.getHot(this.classCode);
    },
    onClickHotSec(name, i) {
      this.hotData = [];
      this.secIndex = i;
      // this.classCode = this.hotClass[i].classCode
      this.classPage = 1;
      this.getHot(this.classCode);
    },
  },
  components: {
    headerApp,
    DownLoadApp,
    LotFilter,
    watermark,
    lottie,
    HomeTabs,
    jinRiCustomSwipe,
    jiJiangCustomSwipe,
  },
};
</script>

<style lang="scss" scoped>
@import url("../assets/css/reset.css");

.resultText {
  font-weight: 400;
  color: #949596;
  font-size: 0.7rem;
  line-height: 1.1rem;
}

.liveIconSty {
  display: inline-block;
  vertical-align: middle;
  background: #f6344b;
  border-radius: 0.7rem;
  margin-right: 0.2rem;
  padding: 0.2rem;
}

.iconList {
  text-align: center;
  justify-content: space-around;
  margin: 0.5rem 0;
  display: flex;
  flex-wrap: wrap;

  /deep/ .van-col {
    position: relative;
  }

  img {
    height: 2rem;
  }

  .hotIcon {
    width: 24px;
    height: 24px;
    top: -8px;
    right: 20px;
    position: absolute;
  }

  .iconListTitle {
    line-height: 1rem;
    font-size: 0.6rem;
    font-weight: 400;
    color: #5d6062;
  }
}

.advertisementIndex {
  width: calc(100% - 1.5rem);
  margin: 0 0.75rem;
  margin-bottom: 0;
  border-radius: 0.5rem;
  overflow: hidden;
  position: relative;

  img {
    width: 100%;
  }

  .advLogo {
    position: absolute;
    bottom: 0.5rem;
    right: 0.5rem;
    width: 30px;
    height: 17px;
  }
}

/deep/.van-loading {
  position: fixed;
  background-color: #fff;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 400;

  .van-loading__spinner {
    position: absolute;
    width: 3rem;
    height: 3rem;
    left: 50%;
    top: 50%;
    margin: -1.5rem 0 0 -1.5rem;
  }
}

/*广告样式*/
.indexAdv {
  padding: 0.75rem 0 0.75rem 0.75rem;
  background-color: #fff;
}

.adColumnLine {
  position: relative;
}

.adColumnLine:after {
  bottom: 0;
  position: absolute;
  height: 0.05rem;
  background-color: #dddee3;
  left: 0;
  right: 0.75rem;
  content: "";
}

.adColumnLine:last-child:after {
  display: none;
}

.advCompanyNameDisplay {
  font-size: 0.55rem;
  color: #969696;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  line-height: 0.8rem;
  height: 0.8rem;
  padding: 0.75rem 0.9rem 0.75rem 0;
}

.advCompanyNameDisplay:before {
  background: url(https://pubunder.artron.net/pubimgs/m/adv_tag_app.png) 0 0
    no-repeat;
  width: 1.5rem;
  height: 0.8rem;
  position: absolute;
  left: 0;
  top: 50%;
  background-size: contain;
  content: "";
  transform: translateY(-50%);
}

/*广告类型92*/
.adColumnLtRp {
  padding-right: 0.75rem;
}

.adColumnLtRp a {
  display: block;
  text-decoration: none;
}

.adColumnLtRp dl {
  overflow: hidden;
  padding: 0;
  margin: 0;
  display: flex;
}

.adColumnLtRp dt {
  height: 4.15rem;
  width: 11.1rem;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  color: #27282d;
  font-size: 0.8rem;
  line-height: 1.1rem;
}

.adColumnLtRp dd {
  float: right;
  width: 5.65rem;
  height: 4.15rem;
  display: -webkit-box;
  -webkit-box-pack: center;
  -webkit-box-orient: vertical;
  -webkit-box-align: center;
  background-color: #e7e7e7;
  border-radius: 0.5rem;
  overflow: hidden;
}

/*广告类型93*/
.adColumnGroupPic {
  position: relative;
  background-color: #fff;
  padding-right: 0.75rem;
}

.adColumnGroupPic .adColumnGroupLink {
  display: block;
}

.adColumnGroupPic .adColumnGroupTit {
  padding: 0.75rem 0 0.75rem 0;
  margin: 0;
  color: #27282d;
  max-height: 2.2rem;
  overflow: hidden;
  line-height: 1.1rem;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 0.8rem;
  text-decoration: none;
  font-weight: normal;
}

.adColumnGroupList,
.adColumnGroupList li {
  padding: 0;
  margin: 0;
  list-style: none;
  overflow: hidden;
}

.adColumnGroupList {
  overflow: hidden;
  position: relative;
  z-index: 2;
}

.adColumnGroupList li {
  width: 5.65rem;
  height: 4.15rem;
  margin-right: 0.15rem;
  float: left;
}

.adColumnGroupList li:last-child {
  margin-right: 0;
}

.adColumnGroupList img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.5rem;
  overflow: hidden;
}

/*广告类型94*/
.adColumnBigPic {
  padding-right: 0.75rem;
}

.adColumnBigPic a {
  text-decoration: none;
  display: block;
}

.adColumnBigPic .adColumnBigPicTit {
  line-height: 1.1rem;
  font-size: 0.8rem;
  color: #27282d;
  padding: 0.75rem 0;
  font-weight: normal;
}

.adColumnBigPicInfo {
  display: -webkit-box;
  width: 100%;
  height: 9.7rem;
  -webkit-box-pack: center;
  -webkit-box-orient: vertical;
  -webkit-box-align: center;
  background-color: #e7e7e7;
  overflow: hidden;
  border-radius: 0.5rem;
}

.adColumnBigPic img,
.adColumnBigPic video {
  max-width: 100%;
  max-height: 100%;
}

/*广告类型95*/
.adColumnBigVideo {
  position: relative;
  background-color: #fff;
  padding-right: 0.75rem;
}

.adColumnBigVideo .adColumnBigPicTit {
  line-height: 1.1rem;
  font-size: 0.8rem;
  color: #27282d;
  padding: 0.75rem 0;
  font-weight: normal;
}

.adColumnBigVideo .adColumnBigVideoLink {
  position: absolute;
  display: block;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 2;
  text-decoration: none;
}

.adColumnBigVideoInfo {
  width: 100%;
  height: 9.7rem;
  background-color: #e7e7e7;
  border-radius: 0.5rem;
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.adColumnBigVideo img,
.adColumnBigVideo video {
  width: 100%;
  height: 9.7rem;
}

/*广告类型96*/
.adColumnScrollBox {
  position: relative;
}

.adColumnScrollBox .adColumnScrollLink {
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  z-index: 10;
}

.adColumnScrollBox .adColumnScrollTit {
  max-height: 2.2rem;
  line-height: 1.1rem;
  padding: 0.75rem 0;
  font-size: 0.8rem;
  color: #27282d;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.adColumnScrollDiv {
  overflow: hidden;
  position: relative;
  z-index: 1;
}

.adColumnScrollDiv li {
  width: 15rem;
  height: 8.45rem;
  float: left;
  margin-right: 0.6rem;
  background-color: #e7e7e7;
  overflow: hidden;
  border-radius: 0.5rem;
}

.adColumnScrollBox img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.index {
  width: 100%;
  margin: 0 auto;
  background: #fff;
}

.floatingWindow {
  position: fixed;
  right: 0;
  top: 60%;
  width: 4rem;
  // height: 4.5rem;
  z-index: 999;
  text-align: center;

  .floatingCloseIcon {
    // position: absolute;
    // bottom: 0;
    height: 1rem;
  }

  .floatingWindowImg {
    width: 100%;
    max-width: none;
  }
}

/* 轮播 */
.swiper {
  padding: 0.17rem 0.75rem;
}

.swiper /deep/.van-swipe {
  height: 8.05rem;
  width: 100%;
  border-radius: 0.5rem;
  overflow: hidden;
}

.swiper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.swiper /deep/ .van-swipe__indicators {
  bottom: 0.5rem;
}

.swiper /deep/ .van-swipe__indicator {
  width: 0.2rem;
  height: 0.2rem;
  margin-right: 0.4rem;
  background: #fff;
  opacity: 0.5;
  transition: 0.2s all ease-in-out;
  border-radius: 0.1rem;
}

.swiper /deep/ .van-swipe__indicator--active {
  opacity: 1;
  width: 0.8rem;
}

/*深度解读*/
.deepReadBox {
  margin: 0.25rem 0.75rem 1rem;
  border-radius: 0.5rem;
  overflow: hidden;
  padding: 0.55rem 0 0.55rem 3.7rem;
  line-height: 0.9rem;
  background: #f2f7fa url("../assets/img/bg_shendu@2x.png") no-repeat 0.5rem
    center;
  background-size: 2.7rem auto;
}

.deepReadSwiper {
  border-left: 0.05rem solid #dddee3;
  padding-left: 0.5rem;
  position: relative;
  height: 0.9rem;
  overflow: hidden;
}

.deepSwiperItem {
  width: 11.85rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.65rem;
  color: #666666;
}

/*月度热门*/
.indexHot {
  margin: 0 0.75rem;
  overflow: hidden;
}

.indexHot .hotBox {
  height: 5.5rem;
  float: left;
  background-color: #dfedff;
  border-radius: 0.5rem;
  overflow: hidden;
  width: 11.25rem;
}

.indexHot .hotBox dt {
  width: 4.15rem;
  float: left;
}

.indexHot .hotBox dt img {
  width: 4.15rem;
  height: 5.5rem;
  object-fit: cover;
}

.indexHot .hotBox dd {
  width: 7.1rem;
  padding: 0 0.3rem;
  float: left;
  height: 5.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.indexHot .hotBox h3 {
  display: flex;
  justify-content: space-between;
  line-height: 1rem;
  padding: 0.5rem 0 0.5rem;
}

.indexHot .hotBox .time {
  color: #286af1;
  font-weight: bold;
  font-size: 0.8rem;
}

.indexHot .hotBox .title {
  color: #286af1;
  font-weight: 400;
  font-size: 0.7rem;
}

.indexHot .hotBox p {
  font-size: 0.65rem;
  color: #666666;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
  line-height: 0.9rem;
  margin-bottom: 0.3rem;
}

.indexHot .hotBox .orgName {
  margin-bottom: 0.5rem;
  font-size: 0.65rem;
  line-height: 0.9rem;
  color: #286af1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hotJump {
  height: 5.5rem;
  width: 5.5rem;
  float: right;
}

.hotJump a {
  display: block;
}

//.hotJump a:last-child{margin-top: .5rem;}
.hotJump img {
  height: 2.5rem;
}

.hotJump .hotJumpTwo {
  display: inline-flex;
  margin-right: 0.5rem;
  margin-top: 0.2rem;
}

.hotJump .hotJumpTwo:last-child {
  margin-right: 0;
}

/*拍卖会列表*/
.indexTit {
  padding: 1.5rem 0.75rem 0.35rem;
  line-height: 1.4rem;
  overflow: hidden;
  &.align-items {
    display: flex;
    align-items: center;
  }
}

.indexTit .name {
  float: left;
  font-size: 1rem;
  color: #27282d;
  font-weight: bold;
}
.indexTit .arrow {
  width: 0.8rem;
  height: 0.8rem;
  display: inline-block;
  background: url("../assets/img/icon_arrow@2x.png") no-repeat center center;
  background-size: 0.8rem 0.8rem;
}

.indexTit .more {
  float: right;
  background: url("../assets/img/icon_list_more_light@2x.png") no-repeat right
    center;
  background-size: 0.5rem auto;
  font-size: 0.75rem;
  color: #666;
  padding-right: 0.9rem;
}

.ad-wrap {
  padding: 0 0.75rem;
  display: flex;
  .bottom-ad {
    width: calc((100% - 0.5rem) / 2);
    margin: 0.5rem 0.5rem 0 0;
    position: relative;
    img {
      display: block;
      border-radius: 0.5rem;
    }
    .advLogo {
      position: absolute;
      bottom: 0.5rem;
      right: 0.5rem;
      width: 30px;
      height: 17px;
    }
  }
  .bottom-ad:last-child {
    margin-right: 0;
  }
}
.swiper-wrapper {
  position: relative;
  width: 100%;
  height: 100%;
  z-index: 1;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-transition-property: -webkit-transform;
  transition-property: -webkit-transform;
  transition-property: transform;
  transition-property: transform, -webkit-transform;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}

.swiper-container-vertical > .swiper-wrapper {
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
}

.swiper-slide {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  width: 100%;
  height: 100%;
  position: relative;
  -webkit-transition-property: -webkit-transform;
  transition-property: -webkit-transform;
  transition-property: transform;
  transition-property: transform, -webkit-transform;
}

.aucSwiper {
  padding-left: 0.25rem;
  overflow-x: auto;
  width: 100%;
}

.aucSwiper::-webkit-scrollbar {
  display: none;
}

.aucSwiper .swiper-wrapper {
  display: flex;
}

.aucSwiper .swiper-slide {
  width: 12rem;
  margin-left: 0.5rem;
}

.aucSwiper a {
  display: block;
}

.aucSwiper dt {
  height: 6.75rem;
  margin-bottom: 0.5rem;
  border-radius: 0.5rem;
  overflow: hidden;
  position: relative;
}

.aucSwiper dt img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.aucSwiper dt .aucStatusBox {
  position: absolute;
  left: 0.5rem;
  top: 0.5rem;
  padding: 0 0.4rem;
  border-radius: 0.7rem;
  background-color: #fff;
  font-size: 0;
}
.pause {
  padding: 0;
}
.pause i {
  color: #009b5f;
  font-size: 1rem;

  vertical-align: middle;
}

.aucSwiper dt .aucStatusBoxType2 {
  position: absolute;
  right: 0.3rem;
  top: 0.3rem;
  border-radius: 0.9rem;
  background-color: rgba(0, 0, 0, 0.5);
  font-size: 0;
  padding: 0.1rem 0.3rem;

  img {
    height: 0.58rem;
    width: 1.7rem;
  }
}

.aucSwiper dt .aucLive {
  color: #000;
  font-size: 0.6rem;
  padding: 2px;
  display: inline-block;
  line-height: 1rem;
}

.aucSwiper dt .aucLive img {
  height: 0.5rem;
  width: 0.45rem;
}

.aucSwiper dt .aucBegin {
  background-color: #000;
}

.aucSwiper dt .aucNum {
  padding: 0 0.3rem;
  color: #fff;
  font-size: 0.6rem;
}

.aucSwiper dt .bigFlag {
  position: absolute;
  background: url("../assets/img/icon_list_HDpic_26@2x.png") no-repeat;
  background-size: 100% 100%;
  width: 1.7rem;
  height: 0.8rem;
  right: 0;
  top: 0;
}

.aucSwiper .title {
  padding: 0;
  line-height: 1.1rem;
  margin-bottom: 0.2rem;
  font-size: 0.8rem;
  color: #27282d;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;

  img {
    vertical-align: middle;
    margin-right: 0;
    height: 0.95rem;
  }
}

.aucSwiper .time {
  font-size: 0.6rem;
  color: #969696;
  line-height: 0.8rem;
  margin-bottom: 0.2rem;
  // padding-left: 1.1rem;
  // background: url("../assets/img/icon_clock.png") no-repeat;
  // background-size: .8rem auto;
}

.aucSwiper .company {
  font-size: 0.8rem;
  color: #27282d;
  line-height: 1.1rem;
  font-weight: 500;
  margin-top: 0.1rem;

  // padding-left: 1.1rem;
  // background: url("../assets/img/icon_list_other_light@2x.png") no-repeat;
  // background-size: .8rem auto;
}

.aucSwiper .aucFlag {
  font-size: 0;
  margin-top: 0.5rem;
}

.aucSwiper .aucFlag span {
  display: inline-block;
  white-space: nowrap;
  line-height: 0.9rem;
  border: 0.05rem solid #d8d8d8;
  border-radius: 0.1rem;
  padding: 0 0.2rem;
  font-size: 0.55rem;
  color: #969696;
  margin-right: 0.3rem;
}

.indexRank .resultPrice {
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  text-align: center;
  font-size: 0.8rem;
  font-weight: 400;
  color: #ffffff;
  padding-top: 2.3rem;
}

/*拍卖结果*/
.indexResult dl {
  margin: 0;
  // background: #FFFFFF;
  // box-shadow: 0rem 0rem 0.5rem 0rem rgba(0, 0, 0, 0.1);
  // border-radius: 0.5rem;
  padding: 0.75rem 0;
}

.indexResult dl:last-child {
  margin-bottom: 0.5rem;
}

.indexResult dt {
  margin-bottom: 0.5rem;
  font-size: 0.8rem;
  line-height: 1.1rem;
  font-weight: bold;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  position: relative;
}

.indexResult .resultNum {
  line-height: 0.85rem;
  font-size: 0.6rem;
  color: #969696;
  overflow: hidden;
  padding-bottom: 0.5rem;
  display: flex;
  justify-content: space-between;
}

.indexResult .resultPrice strong,
.indexResult .resultPrice {
  position: absolute;
  bottom: 0;
  padding: 0.3rem 0.5rem;
  color: #fff;
  font-size: 0.6rem;
  background: rgba(0, 0, 0, 0.4);
  width: 100%;
  font-weight: 400;
  line-height: 0.8rem;

  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 90%;
    display: block;
  }
}

.indexResult .resultInfo {
  padding-top: 0.7rem;
  border-top: 0.05rem dashed rgba(0, 0, 0, 0.1);
  position: relative;
}

.indexResult .resultInfo p {
  width: 70%;
  line-height: 0.9rem;
  font-size: 0.65rem;
  color: #969696;
  margin-bottom: 0.25rem;
}

.indexResult .resultInfo p:last-child {
  margin-bottom: 0;
}

.indexResult .resultImg {
  position: absolute;
  width: 3.5rem;
  height: 4rem;
  right: 0.5rem;
  top: 0.5rem;
  border-radius: 0.2rem;
}

.indexResult .resultImg img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 3;
  position: absolute;
  border-radius: 0.2rem;
}

.indexResult .resultImg .specialsBox {
  border-radius: 0.2rem;
  width: 100%;
  height: 1rem;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  position: absolute;
  text-align: center;
  bottom: 0;
  z-index: 4;
}

.indexResult .resultImg .imgBg1 {
  border-radius: 0.2rem;
  right: -0.4rem;
  width: 100%;
  height: 80%;
  color: #fff;
  background: #999999;
  position: absolute;
  text-align: center;
  bottom: 0;
  z-index: 2;
}

.indexResult .resultImg .imgBg2 {
  border-radius: 0.2rem;
  right: -0.7rem;
  width: 100%;
  height: 70%;
  color: #fff;
  background: #cccccc;
  position: absolute;
  text-align: center;
  bottom: 0;
  z-index: 1;
}

/*首页拍卖广告*/

/*排行榜*/
.rankSwiper {
  overflow: hidden;
}

.rankSwiper .swiper-slide {
  margin-left: 0.75rem;
  width: 16.25rem;
  overflow: hidden;
}

.rankSwiper .swiper-slide:last-child {
  margin-right: 1.5rem;
}

.rankTit {
  font-size: 0.8rem;
  font-weight: bold;
  color: #27282d;
  display: flex;
  margin-bottom: 1rem;
  line-height: 0.9rem;
  position: relative;
  z-index: 2;
  background-color: #fff;
  white-space: nowrap;
  align-items: center;
}

.rankTit .screen {
  width: 2.6rem;
  height: 1.1rem;
  line-height: 1.1rem;
  border: 0.05rem solid #18bd6f;
  text-align: center;
  border-radius: 0.55rem;
  background-color: #e2f3eb;
  font-size: 0.7rem;
  color: #18bd6f;
  margin-left: 0.55rem;
}

.rankTit:before {
  display: inline-block;
  width: 0.25rem;
  height: 0.9rem;
  border-radius: 0.125rem;
  background-color: #18bd6f;
  margin-right: 0.5rem;
  content: "";
}

.rankSwiper dl {
  overflow: hidden;
  margin-bottom: 1.5rem;
}

.rankSwiper dl /deep/.van-image__loading {
  .van-icon-photo {
    width: 1.3rem;
    height: 1.3rem;
    background: url("../assets/img/default.png") no-repeat center;
    background-size: cover;
  }

  .van-icon-photo::before {
    content: "";
  }
}

.rankSwiper dl:last-child {
  margin-bottom: 0;
}

.rankSwiper dt {
  width: 4.6rem;
  height: 4.6rem;
  overflow: hidden;
  border-radius: 0.5rem;
  position: relative;
  float: left;
}

.rankSwiper dt:after {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.02);
  content: "";
  left: 0;
  top: 0;
}

.rankSwiper dt img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.rankSwiper dt span {
  display: inline-block;
  line-height: 0.8rem;
  width: 1.15rem;
  text-align: center;
  color: #fff;
  font-size: 0.7rem;
  font-weight: bold;
  border-radius: 0.5rem 0 0.2rem 0;
  background-color: #a5a5a5;
  position: absolute;
  left: 0;
  top: 0;
}

.rankSwiper dd {
  float: left;
  margin-left: 0.5rem;
  width: 10.4rem;
  height: 4.6rem;
}

.rankSwiper dd .name {
  line-height: 1.1rem;
  font-weight: bold;
  font-size: 0.8rem;
  color: #27282d;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-box-orient: vertical;
  overflow: hidden;
  word-break: break-all;
  margin-bottom: 0.5rem;
}

.rankSwiper dd p {
  margin-bottom: 0.15rem;
  line-height: 0.9rem;
  font-size: 0.65rem;
  color: #969696;
}

.rankSwiper dd p strong {
  display: inline-block;
  width: 3.1rem;
}

.rankSwiper dd p .price {
  color: #e93b3d;
}

.rankSwiper dd p .price i {
  font-size: 0.55rem;
}

.rankSwiper .productRank p {
  padding-left: 0.95rem;
  background-position: left center;
  background-repeat: no-repeat;
  background-size: 0.65rem;
}

.rankSwiper .company {
  background-image: url("../assets/img/icon_list_other_light@2x.png");
}

.rankSwiper .productRank .price {
  background-image: url("../assets/img/icon_list_cheng_light@2x.png");
  color: #e93b3d;
}

.rankSwiper .productRank .time {
  background-image: url("../assets/img/icon_list_time_light@2x.png");
}

.rankSwiper .productRank .name {
  -webkit-line-clamp: 1;
}

.rankSwiper .rankArtist p strong {
  display: inline-block;
  width: auto;
  margin-right: 0.5rem;
}

.rankSwiper .screenPop {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0);
  z-index: -1;
}

.rankSwiper .screenBg {
  background: #000;
  opacity: 0;
  transition: 0.2s opacity ease-in-out;
  position: absolute;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.rankSwiper .screenBox {
  background-color: #fff;
  padding: 0 0 0.75rem 0.75rem;
  transition: 0.2s transform ease-in-out;
  transform: translateY(-100%);
  z-index: 2;
  position: relative;
}

.rankSwiper .screenBox span {
  display: inline-block;
  line-height: 1.4rem;
  margin-right: 0.5rem;
  background-color: #f7f7f7;
  border-radius: 0.7rem;
  color: #27282d;
  font-size: 0.7rem;
  white-space: nowrap;
  padding: 0 0.5rem;
  margin-bottom: 0.5rem;
}

.rankSwiper .screenBox .curr {
  background-color: #e2f3eb;
  color: #18bd6f;
}

.rankSwiper .showScreen {
  z-index: 1;
}

.rankSwiper .showScreen .screenBg {
  opacity: 0.4;
}

.rankSwiper .showScreen .screenBox {
  transform: translateY(0);
}

/*拍卖新闻*/
.indexNews dl {
  margin: 0 0.75rem;
  border-bottom: 0.05rem solid #dddee3;
  padding: 0.75rem 0;
}

.indexNews dl:last-child {
  border-bottom: 0;
}

.indexNews dt {
  display: flex;
  justify-content: space-between;
}

.indexNews .newsTit {
  font-size: 0.8rem;
  color: #27282d;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-align: justify;
  max-height: 2.2rem;
  line-height: 1.1rem;
}

.indexNews .newsImg {
  width: 5.65rem;
  height: 4.15rem;
  margin-left: 0.5rem;
  border-radius: 0.5rem;
  position: relative;
  overflow: hidden;
}

.indexNews .newsImg .icoVideo {
  width: 1.7rem;
  height: 1.7rem;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: url("../assets/img/icon_btn_play@2x.png") no-repeat;
  background-size: cover;
}

.indexNews .newsImg img,
.indexNews .newsImgList img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.indexNews .newsImgList {
  overflow: hidden;
  margin-top: 0.5rem;
}

.indexNews .newsImgList li {
  float: left;
  width: 5.65rem;
  height: 4.15rem;
  margin-right: 0.15rem;
  border-radius: 0.5rem;
  overflow: hidden;
}

.indexNews .newsImgList li:last-child {
  margin-right: 0;
}

.indexNews .newsListInfo {
  margin-top: 0.5rem;
  line-height: 0.85rem;
  font-size: 0.6rem;
  color: #969696;
  display: flex;
  justify-content: space-between;
}

.indexNews .newsListInfo .newsShow {
  background: url("../assets/img/icon_discover_yuedu_light@2x.png") no-repeat
    left center;
  background-size: 0.5rem auto;
  padding-left: 0.7rem;
}

.indexNews .newsVideo dt {
  display: block;
}

.indexNews .newsVideo .newsTit {
  margin-bottom: 0.5rem;
}

.indexNews .newsVideo .newsImg {
  width: 100%;
  margin-left: 0;
  height: 7.25rem;
}

.indexNews .newsVideo .flag {
  position: absolute;
  right: 0;
  top: 0.5rem;
  height: 0.8rem;
  background: #18bd6f;
  padding: 0 0.5rem;
  color: #fff;
  text-align: center;
  font-size: 0.5rem;
  line-height: 0.9rem;
  border-top-left-radius: 1rem;
  border-bottom-left-radius: 1rem;
}

.singleList {
  width: 100%;
  overflow: auto;
  height: 8.8rem;
  padding: 0 1rem;
  white-space: nowrap;
}

.singleList::-webkit-scrollbar {
  height: 1px;
}

.singleList .singleBox {
  width: 5rem;
  height: 8rem;
  margin-right: 0.5rem;
  display: inline-block;
}

.singleList .singleBox .singleImg {
  position: relative;
  border-radius: 0.7rem;
}

.singleList .singleBox .singleImg .collectionnum {
  position: absolute;
  border-radius: 0.7rem;
  color: #ffffff;
  background: rgba(0, 0, 0, 0.7);
  bottom: 0.3rem;
  right: 0.5rem;
  padding: 0 0.5rem;
  font-size: 0.55rem;
}

.singleList .singleBox .singleImg img {
  position: relative;
  border-radius: 0.5rem;
}

.singleList .singleBox .singleName {
  height: 2rem;
  color: #969696;
  line-height: 2rem;
}

/*拍卖指数*/

.hotList {
  padding: 0 0.75rem;
  min-height: 100vh;

  /deep/.van-list {
    width: 100%;
    position: relative;
    padding-bottom: 4rem;
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }

  /deep/.van-loading {
    position: relative;

    .van-loading__spinner {
      position: relative;
      margin: 0;
      top: 0%;
      left: inherit;
    }
  }

  /deep/.van-list__finished-text {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
  }
}

.hotList .dl {
  width: 100%;
  display: inline-block;
}

.hotList .dl:last-child {
  border-bottom: 0;
}

.hotList .dt {
  float: left;
  width: 100%;
  border-radius: 0.4rem;
  background-color: #f7f7f7;
  overflow: hidden;
  position: relative;
}

.hotList .dt .live {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1rem;
  background: #1bbd6f;
  font-size: 0;
}

.hotList .dt .liveReview {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 1.1rem;
  background: rgba(0, 0, 0, 0.85);
  font-size: 0.65rem;
  line-height: 1.1rem;
  color: #ffffff;
  text-align: center;
}

.hotList .dt .HiPic {
  background: url(../assets/img/icon_list_HDpic_26@2x.png) no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  width: 1.7rem;
  height: 0.8rem;
  background-size: 100% 100%;
}

.hotList .dt img {
  width: 100%;
  height: 100%;
  max-height: 400px;
  object-fit: cover;
}

.hotList .dd {
  float: left;
  position: relative;
  width: 100%;
  margin-bottom: 0.5rem;
}

.hotList .hotName {
  line-height: 1.05rem;
  font-size: 0.7rem;
  color: #27282d;
  display: -webkit-box;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-height: 2.1rem;
  margin: 0.2rem 0;
}

.hotList .labelBox {
  width: 100%;
  margin: 0.3rem 0;

  .greenBox {
    background: rgba(0, 155, 95, 0.1);
    border-radius: 3px 3px 3px 3px;
    padding: 2px 4px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 11px;
    color: #009b5f;
    display: inline-block;
  }

  .redBox {
    background: rgba(235, 81, 100, 0.1);
    border-radius: 3px 0px 0px 3px;
    padding: 2px 4px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 600;
    font-size: 11px;
    color: #eb5164;
    display: inline-block;
  }

  .timeBox {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    display: inline-block;
    font-size: 10px;
    color: rgba(0, 0, 0, 0.8);
  }
}

.hotList .followBox {
  position: absolute;
  width: 1.2rem;
  height: 1.2rem;
  right: 0.2rem;
  top: 0.2rem;
}
.restrictTransportIcon{
                    width: 2.05rem !important;
                    height: 0.9rem !important;
                    position: absolute;
                    top: .5rem;
                    left: .5rem;
                }

.hotList .hotName .flag {
  display: inline-block;
  width: 1.9rem;
  height: 0.7rem;
  margin-right: 0.15rem;
  background-size: cover;
  vertical-align: -0.05rem;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

/* icon数字 5已结拍 4拍卖中 3待预展 2预展中 1待拍卖 */
.hotList .hotName .item-icon5 {
  background-image: url(../assets/img/icon_list_tag_grey@2x.png);
}

.hotList .hotName .item-icon4 {
  background-image: url(../assets/img/icon_list_tag_red@2x.png);
}

/* 这个待预展暂时没有图片 */
.hotList .hotName .item-icon3 {
  background-image: url(../assets/img/icon_list_tag_green2.png);
}

.hotList .hotName .item-icon2 {
  background-image: url(../assets/img/icon_list_tag_green.png);
}

.hotList .hotName .item-icon1 {
  background-image: url(../assets/img/icon_list_tag_green@2x.png);
}

.hotList .hotFlag {
  margin-top: 0.3rem;
  font-size: 0;
}

.hotList .hotFlag .tag {
  display: inline-block;
  height: 0.8rem;
  background-repeat: no-repeat;
  background-size: contain;
  line-height: 0.8rem;
  padding: 0 0.2rem;
  color: #969696;
  font-size: 0.5rem;
  border: 0.05rem solid #d8d8d8;
  border-radius: 0.1rem;
}

.hotList .hotFlag .tag:last-child {
  margin-right: 0;
}

//.hotList .hotFlag .videoLive {
//    width: 2.4rem;
//    background-image: url(../assets/img/icon_video_live.png);
//}
//.hotList .hotFlag .imgLive {
//    width: 2.4rem;
//    background-image: url(../assets/img/icon_img_live.png);
//}
//.hotList .hotFlag .tbPai {
//    width: 1.8rem;
//    background-image: url(../assets/img/icon_tbpai.png);
//}
.hotList .hotFlag span {
  display: inline-block;
  margin-right: 0.3rem;
}

.hotList .hotInfo {
  margin-top: 0.6rem;
  width: 100%;
}

.hotList .hotInfo .price {
  color: #969696;
  font-size: 0.65rem;
  line-height: 0.9rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.company {
  width: 100%;
  color: #969696;
  font-size: 0.65rem;
  line-height: 0.9rem;
  margin-bottom: 0.15rem;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.companyCity {
  width: 55%;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
}

.companySpan {
  text-align: right;
  display: inline-block;
  vertical-align: top;
  width: 42.5%;
}

.hotList .hotInfo .price {
  // background-image: url("../assets/img/icon_list_gu_light@2x.png");
  // color: #E93B3D;
}

.hotList .hotInfo .price i {
  margin: 0 0.3rem;
}

.hotList .hotInfo .price span {
  color: #000;
  font-weight: bolder;
  float: right;
  width: calc(100% - 3.9rem);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.hotList .hotInfo .time {
  // background-image: url("../assets/img/icon_list_time_light@2x.png");
}

.hotList .hotInfo .orgName {
  // background-image: url("../assets/img/icon_list_other_light@2x.png");
}

.hotList .gotoAppBtn {
  height: 1rem;
  line-height: 1rem;
  border: 0.05rem solid #18bd6f;
  color: #18bd6f;
  font-size: 0.5rem;
  text-align: center;
  position: absolute;
  right: 0;
  bottom: 1rem;
  border-radius: 0.5rem;
  padding: 0 0.5rem;
}

.indexHotList .indexTit {
  padding-top: 0.5rem;
  font-size: 1rem;
  font-weight: bold;
}

.indexHotList .searchTop {
  text-align: right;
  width: 100%;
  padding: 0rem 0.75rem 0.5rem 0.75rem;
  margin-bottom: 0.2rem;
}

.searchBottom {
  display: flex;
  justify-content: flex-start;
  width: 100%;
  padding: 0rem 0.75rem 0.5rem 0.75rem;
  margin-bottom: 0.5rem;

  .activeDiv {
    background: #009b5f;
    color: #fff;
  }

  div {
    background: #f5f5f5;
    padding: 5px 10px;
    border-radius: 36px 36px 36px 36px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #6b6c6c;
    margin-right: 10px;
  }
}

.auction-filter {
  width: 50px;
  display: inline-block;
}

.listText {
  width: calc(100% - 60px);
  color: #949596;
  text-align: left;
  display: inline-block;

  .sortBox {
    display: inline-block;
    margin-right: 0.5rem;

    img {
      vertical-align: text-bottom;
      width: 1rem;
    }
  }

  .sortCheck {
    vertical-align: inherit;
    zoom: 0.9;
    /deep/.van-checkbox__label {
      color: #949596;
      font-weight: 600;
      font-size: 0.75rem;
    }

    /deep/.van-icon {
      border-radius: 30%;
    }

    /deep/.van-checkbox__icon--checked {
      .van-icon {
        background-color: #009b5f;
        border-color: #009b5f;
      }
    }
  }
}

.indexHotList /deep/.van-tab {
  font-size: 0.75rem;
  line-height: 1.05rem;
}

.indexHotList /deep/.van-tab--active {
  color: #18bd6f;
}

.indexHotList /deep/.van-tabs__line {
  width: 1.5rem;
  height: 0.15rem;
  background-color: #18bd6f;
  border-radius: 0;
  bottom: -0.075rem;
}

.indexHotList /deep/.van-tabs__nav--line {
  border-bottom: 0.05rem solid #dddee3;
  padding-bottom: 0;
  height: 2rem;
  overflow: visible;
}

.indexHotList /deep/.van-tabs--line .van-tabs__wrap {
  height: 2.2rem;
  background-color: #fff;
}

.indexHotList /deep/.tabFix.van-tabs--line .van-tabs__wrap {
  position: fixed;
  width: 100%;
  left: 0;
  z-index: 1;
}

.indexHotList /deep/.tabFix .van-tabs__content {
  margin-top: 2.2rem;
}

/*专场广告*/
.advSpecial {
  padding: 0 0.75rem;
  margin-top: 1rem;

  .imgCenter {
    height: 6.7rem;
    border-radius: 0.5rem;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .advText {
    line-height: 1.1rem;
    margin: 0.5rem 0 0rem;
    color: #27282d;
    font-size: 0.8rem;
  }
}

.indexHotTabs {
  position: relative;

  // &:after {
  //     content: '';
  //     width: 100%;
  //     display: block;
  //     height: .05rem;
  //     background-color: #dddee3;
  //     bottom: .075rem;
  //     position: absolute;
  // }

  .indexHotTabsBox {
    overflow-y: hidden;
    overflow-x: auto;
    position: relative;
    z-index: 1;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .indexTabsCon {
    display: flex;
    height: 2rem;
    padding: 0 0.25rem;
    margin-bottom: 0.5rem;

    .indexHotTab {
      display: flex;
      color: #6b6c6c;
      font-size: 0.8rem;
      line-height: 1.05rem;
      padding: 0 12px;
      flex: 1 0 auto;
      align-items: center;
      position: relative;
    }

    .indexHotTabSec {
      font-size: 0.55rem;
      line-height: 2.05rem;
      padding: 0 12px;
    }

    .indexHotTabSec:after {
      display: none !important;
    }

    .active {
      font-weight: 600;
      color: #000000;
    }

    // .active:after {
    //     display: block;
    //     content: '';
    //     height: .15rem;
    //     width: 1.5rem;
    //     background-color: #18BD6F;
    //     bottom: 0;
    //     position: absolute;
    //     left: 50%;
    //     transform: translateX(-50%);
    // }
  }
}
</style>
